import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "faq",
  class: "faq-subsection"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Questions Fréquentes", -1)
const _hoisted_3 = { class: "faq-list" }
const _hoisted_4 = ["aria-expanded", "onClick"]
const _hoisted_5 = { class: "faq-question" }
const _hoisted_6 = {
  key: 0,
  class: "faq-answer-wrapper"
}
const _hoisted_7 = { class: "faq-answer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (item, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.q,
          class: _normalizeClass(["faq-item", { 'first-open': idx === 0 }])
        }, [
          _createElementVNode("button", {
            class: "faq-header",
            type: "button",
            "aria-expanded": _ctx.isOpen(idx),
            onClick: ($event: any) => (_ctx.toggle(idx))
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(item.q), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["chevron", { open: _ctx.isOpen(idx) }]),
              "aria-hidden": "true"
            }, "▼", 2)
          ], 8, _hoisted_4),
          (_ctx.isOpen(idx))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(item.a), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ])
  ]))
}